module.exports = __webpack_public_path__ + "img/knue_gallery4.303da6b9.jpg";